import ProjectCard from "../../components/project-card/ProjectCard"
import {useEcpProjectsContext} from "../../reactContext/contextCustomHooks/useEcpProjectsContext"

export default function EcpProjectsContent({projects}) {
    const {ecpProjectsContext} = useEcpProjectsContext()
    return (
        <>
        <div className="SECTION ECP-PROJECTS-CONTENT">
            {projects.map((project, index) => (
                <ProjectCard key={`project-card-${index}`} project={project} type={"ecp"} tab={ecpProjectsContext.tab}/>
            ))}
        </div>
        </>
    )
}